var ɵ0 = { autoClose: true };
var WorkflowCommonModule = /** @class */ (function () {
    function WorkflowCommonModule() {
    }
    return WorkflowCommonModule;
}());
export { WorkflowCommonModule };
export { ɵ0 };
